import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTemplate]'
})
export class TemplateDirective {

  private _name: string;

  @Input()
  set appTemplate(value: 'header' | 'body' | 'footer') {
    this._name = value;
  }

  get name(): string {
    return this._name;
  }

  constructor(public template: TemplateRef<any>) { }

  getType(): string {
    return this.name;
  }
}
